import i18next from "i18next";
import React from "react";

const LanguageMenu = ({ setOpenLang, languages, findLang }) => {
  return (
    <>
      <ul className="submenu">
        {languages.map((d) => (
          <div
            className="header"
            key={d.code}
            style={{
              padding: "5px 10px",
              cursor: "pointer",
              userSelect: "none",
              pointerEvents: findLang.code === d.code ? "none" : "auto",
              opacity:  findLang.code === d.code ? "0.5" : "1"
            }}
            onClick={() => {
              i18next.changeLanguage(d.code);
              setOpenLang(false);
            }}
          >
            <div className="img">
              <span className={`fi fi-${d.flagCode}`}></span>
            </div>
            <div className="name">{d.name}</div>
          </div>
        ))}
      </ul>
    </>
  );
};

export default LanguageMenu;
